/*
 * (c) Copyright, 2022, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { useServiceContext } from '../../root'
import { useRcmTableData } from '../../hooks/useRcmTableData'

interface RcmTableFilterTriggerProps extends React.HTMLAttributes<HTMLAnchorElement> {
  // Allow any additional anchor props to be passed through
}

const RcmTableFilterTrigger: React.FC<RcmTableFilterTriggerProps> = (props) => {
  const tableData = useRcmTableData()
  const context = useServiceContext()
  const { translate } = context.service.filter

  return (
    <a
      {...props}
      className={'btn-link filterby-expander filterby-expander-react' + (props.className ? ' ' + props.className : '')}
      id="main-filter-btn"
      onClick={(e) => {
        e.preventDefault()
        tableData.setIsFilterCollapsed(!tableData.isFilterCollapsed)
        if (props.onClick) props.onClick(e)
      }}
    >
      <span>{translate('FILTERS_FILTER_BY')}</span>
      <i
        className={
          'filterby-expander-caret-react fa ' +
          (tableData.isFilterCollapsed ? 'fa-caret-down fa-lg' : 'fa-caret-up fa-lg')
        }
      />
    </a>
  )
}

export default RcmTableFilterTrigger
